import { useEffect, useState } from "react";
import "./style.css"
import { FormControlLabel, Switch } from "@mui/material";
import UserService from "../../services/UserService";
import logo from "../../assets/logo.png"
import authApi, { login } from "../../services/api/auth";
import { Botao } from "@/components/Botao";
import { CamposDeEntrada } from "@/components/CamposDeEntrada";
import { severityType } from "@/utils/alert";
import styles from './login.module.css'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { delay } from "@/utils/delay";

const redirectUrl = "/homepage"

export function AuthenticateJWT() {

    useEffect(() => {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const tk = urlParams.get("tk");

        // Verificando parametro
        if (!tk) {
            console.error("Não foi informado o parametro tk")
            window.location.href = "/?LINK"
            return;
        }

        // // Validando token
        // const token = await authApi.validateToken(tk);

        // if(token.status != 200){
        //     console.error("Houve um erro com a requisição: ", token)
        //     window.location.href="/?LINK"
        //     return <></>;
        // }

        authApi.validateToken(tk).then((response) => {
            console.log(response)

            if (response.status != 200 || response.data == undefined) {
                console.error("Houve um erro ao validar o token: ", tk, "\nRequsição: ", response)
                console.log(response)
                window.location.href = "/?LINK"
                return;
            }

            // Setando no service
            UserService.setToken(response.data)
            console.log("deu certo")

            window.location.href = redirectUrl
            return;
        })

    }, [])


    return (
        <></>
    )
}

export function Login() {
    const [loginInfo, setLoginInfo] = useState<string | undefined>("")
    const [password, setPassword] = useState<string | undefined>(undefined)

    const [usePassword, setUsePassword] = useState<boolean>(false)

    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined)
    const [erroLogin, setErroLogin] = useState<boolean>(false)
    const [carregando, setCarregando] = useState<boolean>(false)

    const [alertInfo, setAlertInfo] = useState<{
        severity: severityType
        message: string
    }>({ severity: 'success', message: '' })
    const [showAlert, setShowAlert] = useState(false)

    const errorMessages: { [key: string]: string } = {
        "LINK": "O link que você usou não é mais válido.\nPor favor, faça login novamente",
    }

    function getQueryParam(): string {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        return searchParams.keys().next().value
    }

    useEffect(() => {
        // Limpando o token do localStorage na inicialização da tela
        localStorage.clear();

        const errorMessage = errorMessages[getQueryParam()]

        if (errorMessage)
            setErrorMessage(errorMessage)

        if (UserService.isAuthenticated())
            window.location.href = redirectUrl

    }, [])

    const handleLoginResponse = (token: string, atendant: any) => {
        if (!password || password.trim().length == 0) {
            if (!loginInfo?.includes("@") && !usePassword) {
                setAlertInfo({
                    severity: 'success',
                    message: 'O link de acesso foi enviado no seu whatsapp!',
                });
                setShowAlert(true);
                delay(4100).then(() => {
                    setShowAlert(false);
                })
            } else {
                setAlertInfo({
                    severity: 'success',
                    message: 'O link de acesso foi enviado no seu email!',
                });
                setShowAlert(true);
                delay(4100).then(() => {
                    setShowAlert(false);
                })
            }
            return;
        }

        if (password) {
            UserService.setToken(token)
            UserService.setAttendant(atendant)
            window.location.href = redirectUrl
        }

    }

    // const formatPhone = (phone : string) => {
    //     if(phone.length == 10 || phone.length == 11){
    //         if(!phone.startsWith('55')){
    //             phone = '55' + phone
    //         }
    //         if(phone.length == 13 && phone.charAt(4) == '9'){
    //             phone = phone.substring(0, 4)+phone.substring(4+1)
    //         }
    //         if(phone.length !== 12){
    //             throw Error("Informe o DDD do telefone ou remova o 9")
    //         }
    //     } else if(phone.length != 12){
    //         throw Error("Número de telefone inválido, informe o DDD ou remova o 9")
    //     }
    //     return phone
    // }

    const handleLogin = async () => {
        if (!loginInfo || loginInfo.trim().length == 0) {
            alert("Você precisa informar um telefone ou email para realizar login")
            return;
        }

        setCarregando(true)

        let isPhone = false;
        let phone: string | undefined = undefined;

        if (!loginInfo.includes("@")) {
            isPhone = true
            try {
                phone = loginInfo
                setLoginInfo(phone)
            } catch (err) {
                alert(err)
                setCarregando(false)
                return;
            }
        }

        let loginBody: { phone?: string, email?: string, origin: string, password?: string, usaSenha?: boolean } = { origin: window.location.origin }

        isPhone ? loginBody.phone = phone : loginBody.email = loginInfo;

        usePassword ? loginBody.password = password : null;

        loginBody.usaSenha = usePassword;

        try {
            const login = await authApi.login(loginBody);

            handleLoginResponse(login.data.token, login.data.attendant)
            console.log('Erro', erroLogin)
        } catch (error) {
            setErroLogin(true)
            console.error("Houve um erro com a requisição: ", login)

            if (isPhone && !usePassword) {
                setErrorMessage("Telefone inválido\nInforme o código do país e o ddd.\nExemplo:55 83 9999 9999")
            } else if (isPhone && usePassword) {
                setErrorMessage("Houve um erro, verifique se o telefone ou senha digitada está correto e tente novamente!")
            } else {
                setErrorMessage("Houve um erro, verifique se o email ou senha digitada está correto e tente novamente!")
            }
        } finally {
            setCarregando(false)
        }
    }

    function removeErro() {
        setErrorMessage(undefined)
    }

    const botaoDesabilitado = usePassword && (password === '' || password === undefined) ? true : false;

    function confirmarLoginViaTeclado(e: KeyboardEvent) {
        if (e.key === "Enter") {
            if (usePassword) {
                if (password && password.trim().length > 0) {
                    handleLogin();
                }
            } else if (loginInfo && loginInfo.trim().length > 0) {
                handleLogin();
            }
        }
    }

    useEffect(() => {
        if (!usePassword) {
            setPassword(undefined);
        }
    }, [usePassword]);

    useEffect(() => {
        document.addEventListener("keydown", confirmarLoginViaTeclado);
        return () => {
            document.removeEventListener("keydown", confirmarLoginViaTeclado);
        };
    }, [loginInfo, password, usePassword]);

    return (
        <div className="login-page">

            <div className="form-container">

                <div className="title">
                    <img src={logo} className="login-logo" />
                </div>

                <div className="login-form">
                    <CamposDeEntrada
                        texto="Login"
                        valor={loginInfo}
                        onChange={(e) => { setLoginInfo(e.target.value), errorMessage ? removeErro() : null }}
                        obrigatorio={true}
                    />

                    <FormControlLabel
                        control={<Switch
                            sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': {
                                    color: '#666CFF',
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                    backgroundColor: '#666CFF',
                                },

                            }}
                            onChange={() => { setUsePassword(!usePassword), errorMessage ? removeErro() : null }}
                        />}
                        label="Usar senha"
                    ></FormControlLabel>

                    {
                        usePassword ?
                            <CamposDeEntrada
                                texto="Senha"
                                tipo="password"
                                valor={password}
                                onChange={(e) => { setPassword(e.target.value), errorMessage ? removeErro() : null }}
                                obrigatorio={true}
                            />
                            : <></>
                    }
                    {
                        erroLogin && <p className="error-message">
                            {errorMessage}
                        </p>
                    }
                    {
                        showAlert && (
                            <div className={styles.informacao_login}>
                                <CheckCircleIcon sx={{ color: 'white' }} />
                                <span>{alertInfo.message}</span>
                            </div>
                        )
                    }
                    <Botao
                        modelo={'primario'}
                        variante="contained"
                        onClick={handleLogin}
                        texto={'ENTRAR'}
                        carregando={carregando}
                        desabilitarBotao={botaoDesabilitado}
                    />
                </div>
            </div>
        </div>
    )
}
